(function($, duo, undefined) {

	"use strict";

	// classes:
	

	/**
	 * @class MoodboardProduct
	 */
	class MoodboardProduct {

		/**
		 * Creates an instance of MoodboardProduct
		 * @param {string} MoodboardProductSelector css selector for the MoodboardProduct element
		 */
		constructor({MoodboardProductSelector = '.moodboard__item__product-overlay'} = {}) {
			this.MoodboardProductSelector = MoodboardProductSelector;
			this.element = $(MoodboardProductSelector);

			// setup:
			this.setup();
		} /* constructor */

		/**
		 * Setup the MoodboardProduct
		 */
		setup() {

			// add class if product block exists
			$(this.MoodboardProductSelector).has('.moodboard__item__product').addClass('has-product-item');

			// define height of porduct cta block
			// const moodboardProdCta = $(this.MoodboardProductSelector).find('.moodboard__product__cta-block');
			// const moodboardProdCtaHeight = moodboardProdCta.outerHeight();

			// set negative margin to product overlay block
			// const borderWidths = 4;
			// let negMargin = -moodboardProdCtaHeight - borderWidths;

			let prodBreakpoint = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/["']/g, "");
			
			// paragraph--type-row-f
			if(prodBreakpoint === 'l-s' || prodBreakpoint === 'm' || prodBreakpoint === 's' || prodBreakpoint === 'xs' || prodBreakpoint === 'xxs') {
				// define height of porduct cta block
				let moodboardProdCta = $('.paragraph--type-row-f .moodboard__item__product-overlay').find('.moodboard__product__cta-block');
				let moodboardProdCtaHeight = moodboardProdCta.outerHeight();

				// set negative margin to product overlay block
				let borderWidths = 4;
				let negMargin = -moodboardProdCtaHeight - borderWidths;
				let negMarginProdSticker = negMargin - 40;

				$('.paragraph--type-row-f .moodboard__item__product-overlay').each(function() {
					//$(this).has(moodboardProdCta).css('margin-top', negMargin);
					$(this).css('margin-top', negMargin);
				});

				$('.paragraph--type-row-f .moodboard__item--01 .promotion-sticker').css('top', negMarginProdSticker);


			} else {
				// define height of porduct cta block
				let moodboardProdCta = $('.paragraph--type-row-f .moodboard__item__product-overlay').find('.moodboard__product__cta-block');
				let moodboardProdCtaHeight = moodboardProdCta.outerHeight();

				// set negative margin to product overlay block
				let borderWidths = 4;
				let negMargin = -moodboardProdCtaHeight - borderWidths;

				$('.paragraph--type-row-f .moodboard__item__product-overlay').each(function() {
					//$(this).has(moodboardProdCta).css('margin-top', '');
					$(this).css('margin-top', '');
				});
			}

			// paragraph--type-row-g
			if(prodBreakpoint === 'l-s' || prodBreakpoint === 'm' || prodBreakpoint === 's' || prodBreakpoint === 'xs' || prodBreakpoint === 'xxs') {
				// define height of porduct cta block
				let moodboardProdCta = $('.paragraph--type-row-g .moodboard__item__product-overlay').find('.moodboard__product__cta-block');
				let moodboardProdCtaHeight = moodboardProdCta.outerHeight();

				// set negative margin to product overlay block
				let borderWidths = 4;
				let negMargin = -moodboardProdCtaHeight - borderWidths;
				let negMarginProdSticker = negMargin - 40;

				$('.paragraph--type-row-g .moodboard__item__product-overlay').each(function() {
					//$(this).has(moodboardProdCta).css('margin-top', negMargin);
					$(this).css('margin-top', negMargin);
				});

				$('.paragraph--type-row-g .moodboard__item--02 .promotion-sticker').css('top', negMarginProdSticker);
			} else {
				// define height of porduct cta block
				let moodboardProdCta = $('.paragraph--type-row-g .moodboard__item__product-overlay').find('.moodboard__product__cta-block');
				let moodboardProdCtaHeight = moodboardProdCta.outerHeight();

				// set negative margin to product overlay block
				let borderWidths = 4;
				let negMargin = -moodboardProdCtaHeight - borderWidths;
				
				$('.paragraph--type-row-g .moodboard__item__product-overlay').each(function() {
					//$(this).has(moodboardProdCta).css('margin-top', '');
					$(this).css('margin-top', '');
				});
			}

			// paragraph--type-row-h
			if(prodBreakpoint === 'xl-s' || prodBreakpoint === 'l' || prodBreakpoint === 'l-m' || prodBreakpoint === 'l-s' || prodBreakpoint === 'm' || prodBreakpoint === 's' || prodBreakpoint === 'xs' || prodBreakpoint === 'xxs') {
				// define height of porduct cta block
				const moodboardProdCta = $('.paragraph--type-row-h .moodboard__item__product-overlay').find('.moodboard__product__cta-block');
				let moodboardProdCtaHeight = moodboardProdCta.outerHeight();

				// set negative margin to product overlay block
				const borderWidths = 4;
				let negMargin = -moodboardProdCtaHeight - borderWidths;

				$('.paragraph--type-row-h .moodboard__item__product-overlay').each(function() {
					$(this).has(moodboardProdCta).css('margin-top', negMargin);
				});
			} else {
				// define height of porduct cta block
				let moodboardProdCta = $('.paragraph--type-row-h .moodboard__item__product-overlay').find('.moodboard__product__cta-block');
				let moodboardProdCtaHeight = moodboardProdCta.outerHeight();

				// set negative margin to product overlay block
				let borderWidths = 4;
				let negMargin = -moodboardProdCtaHeight - borderWidths;
				
				$('.paragraph--type-row-h .moodboard__item__product-overlay').each(function() {
					$(this).has(moodboardProdCta).css('margin-top', '');
				});
			}

			// on window resize:
			$(window).resize(function() {

				let prodBreakpoint = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/["']/g, "");

				// paragraph--type-row-f
				if(prodBreakpoint === 'l-s' || prodBreakpoint === 'm' || prodBreakpoint === 's' || prodBreakpoint === 'xs' || prodBreakpoint === 'xxs') {
					// define height of porduct cta block
					let moodboardProdCta = $('.paragraph--type-row-f .moodboard__item__product-overlay').find('.moodboard__product__cta-block');
					let moodboardProdCtaHeight = moodboardProdCta.outerHeight();
	
					// set negative margin to product overlay block
					let borderWidths = 4;
					let negMargin = -moodboardProdCtaHeight - borderWidths;
					let negMarginProdSticker = negMargin - 40;
	
					$('.paragraph--type-row-f .moodboard__item__product-overlay').each(function() {
						//$(this).has(moodboardProdCta).css('margin-top', negMargin);
						$(this).css('margin-top', negMargin);
					});

					$('.paragraph--type-row-f .moodboard__item--01 .promotion-sticker').css('top', negMarginProdSticker);
				} else {
					// define height of porduct cta block
					let moodboardProdCta = $('.paragraph--type-row-f .moodboard__item__product-overlay').find('.moodboard__product__cta-block');
					let moodboardProdCtaHeight = moodboardProdCta.outerHeight();
	
					// set negative margin to product overlay block
					let borderWidths = 4;
					let negMargin = -moodboardProdCtaHeight - borderWidths;

					$('.paragraph--type-row-f .moodboard__item__product-overlay').each(function() {
						//$(this).has(moodboardProdCta).css('margin-top', '');
						$(this).css('margin-top', '');
					});
				}

				// paragraph--type-row-g
				if(prodBreakpoint === 'l-s' || prodBreakpoint === 'm' || prodBreakpoint === 's' || prodBreakpoint === 'xs' || prodBreakpoint === 'xxs') {
					// define height of porduct cta block
					let moodboardProdCta = $('.paragraph--type-row-g .moodboard__item__product-overlay').find('.moodboard__product__cta-block');
					let moodboardProdCtaHeight = moodboardProdCta.outerHeight();
	
					// set negative margin to product overlay block
					let borderWidths = 4;
					let negMargin = -moodboardProdCtaHeight - borderWidths;
					let negMarginProdSticker = negMargin - 40;
	
					$('.paragraph--type-row-g .moodboard__item__product-overlay').each(function() {
						//$(this).has(moodboardProdCta).css('margin-top', negMargin);
						$(this).css('margin-top', negMargin);
					});
					$('.paragraph--type-row-g .moodboard__item--02 .promotion-sticker').css('top', negMarginProdSticker);
				} else {
					// define height of porduct cta block
					let moodboardProdCta = $('.paragraph--type-row-g .moodboard__item__product-overlay').find('.moodboard__product__cta-block');
					let moodboardProdCtaHeight = moodboardProdCta.outerHeight();
	
					// set negative margin to product overlay block
					let borderWidths = 4;
					let negMargin = -moodboardProdCtaHeight - borderWidths;
					
					$('.paragraph--type-row-g .moodboard__item__product-overlay').each(function() {
						//$(this).has(moodboardProdCta).css('margin-top', '');
						$(this).css('margin-top', '');
					});
				}

				// paragraph--type-row-h
				if(prodBreakpoint === 'xl-s' || prodBreakpoint === 'l' || prodBreakpoint === 'l-m' || prodBreakpoint === 'l-s' || prodBreakpoint === 'm' || prodBreakpoint === 's' || prodBreakpoint === 'xs' || prodBreakpoint === 'xxs') {
					// define height of porduct cta block
					const moodboardProdCta = $('.paragraph--type-row-h .moodboard__item__product-overlay').find('.moodboard__product__cta-block');
					let moodboardProdCtaHeight = moodboardProdCta.outerHeight();
	
					// set negative margin to product overlay block
					const borderWidths = 4;
					let negMargin = -moodboardProdCtaHeight - borderWidths;
	
					$('.paragraph--type-row-h .moodboard__item__product-overlay').each(function() {
						$(this).has(moodboardProdCta).css('margin-top', negMargin);
					});
				} else {
					// define height of porduct cta block
					let moodboardProdCta = $('.paragraph--type-row-h .moodboard__item__product-overlay').find('.moodboard__product__cta-block');
					let moodboardProdCtaHeight = moodboardProdCta.outerHeight();
	
					// set negative margin to product overlay block
					let borderWidths = 4;
					let negMargin = -moodboardProdCtaHeight - borderWidths;
					
					$('.paragraph--type-row-h .moodboard__item__product-overlay').each(function() {
						$(this).has(moodboardProdCta).css('margin-top', '');
					});
				}

			});

		} /* setup */

	} /* MoodboardProduct */


	duo.MoodboardProduct = MoodboardProduct;

})(jQuery, window.duo = window.duo || {});
